import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ArrowDown from "./ArrowDown";
import Camera from "./Camera";
import Check from "./Check";
import Clock from "./Clock";
import Cross from "./Cross";
import CrossLarge from "./CrossLarge";
import Delete from "./Delete";
import Expand from "./Expand";
import HealthCheck from "./HealthCheck";
import House from "./House";
import Map from "./Map";
import Plus from "./Plus";
import Search from "./Search";
import StatusError from "./StatusError";
import StatusOk from "./StatusOk";
import User from "./User";
import Switch2 from "./Switch2";
import * as ICON from "../constants/iconNames";
import Pdf from "./Pdf";
const Icon = props => {
    switch (props.name) {
        case ICON.ARROW_DOWN:
            return _jsx(ArrowDown, Object.assign({}, props));
        case ICON.CAMERA:
            return _jsx(Camera, Object.assign({}, props));
        case ICON.CHECK:
            return _jsx(Check, Object.assign({}, props));
        case ICON.CROSS:
            return _jsx(Cross, Object.assign({}, props));
        case ICON.CROSS_LARGE:
            return _jsx(CrossLarge, Object.assign({}, props));
        case ICON.DELETE:
            return _jsx(Delete, Object.assign({}, props));
        case ICON.EXPAND:
            return _jsx(Expand, Object.assign({}, props));
        case ICON.HOUSE:
            return _jsx(House, Object.assign({}, props));
        case ICON.HEALTH_CHECK:
            return _jsx(HealthCheck, Object.assign({}, props));
        case ICON.MAP:
            return _jsx(Map, Object.assign({}, props));
        case ICON.SEARCH:
            return _jsx(Search, Object.assign({}, props));
        case ICON.STATUS_ERROR:
            return _jsx(StatusError, Object.assign({}, props));
        case ICON.STATUS_OK:
            return _jsx(StatusOk, Object.assign({}, props));
        case ICON.PLUS:
            return _jsx(Plus, Object.assign({}, props));
        case ICON.USER:
            return _jsx(User, Object.assign({}, props));
        case ICON.PDF:
            return _jsx(Pdf, Object.assign({}, props));
        case ICON.SWITCH2:
            return _jsx(Switch2, {});
        default:
            return _jsx(Clock, Object.assign({}, props));
    }
};
export default Icon;
